import { Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import { useEffect } from 'react';

import Pricing from './components/Pages/Pricing';
import Onboarding from './components/Pages/Onboarding';
import Benefits from './components/Pages/Benefits';
import Partner from './components/Pages/Partner';
import Profile from './components/Pages/Profile';

function App() {

  useEffect(() => {

    const script = document.createElement('script');
    script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    document.body.appendChild(script);

    window.googleTranslateElementInit = () => {
      // eslint-disable-next-line no-undef
      new window.google.translate.TranslateElement(
        {
          pageLanguage: 'en',
          includedLanguages: 'en,as,bn,brx,doi,gu,hi,kn,ks,gom,mai,ml,mni-Mtei,mr,ne,or,pa,sat,sd,ta,te,ur,bho',
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE
        },
        'google_translate_element'
      );

      // Patch the element directly via inline style — bypasses all stylesheets
      const patchWidget = () => {
        document.querySelectorAll('.VIpgJd-ZVi9od-vH1Gmf').forEach(el => {
          el.setAttribute('style',
            'background-color: transparent !important;' +
            'border: none !important;' +
            'box-shadow: none !important;' +
            'padding: 0 !important;' +
            'overflow: visible !important;'
          );
        });
        document.querySelectorAll('.VIpgJd-ZVi9od-vH1Gmf-ibnC6b, .VIpgJd-ZVi9od-vH1Gmf-ibnC6b span').forEach(el => {
          el.setAttribute('style', 'color: #0e6ebe !important;');
        });
      };

      // Watch body for Google widget rendering
      const observer = new MutationObserver(patchWidget);
      observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });

      setTimeout(patchWidget, 800);
      setTimeout(patchWidget, 2000);
    };
  }, []);

  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Pricing />} />
          <Route path="onboarding" element={<Onboarding />} />
          <Route path="benefits" element={<Benefits />} />
          <Route path="partner" element={<Partner />} />
          <Route path="profile" element={<Profile />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
